import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { getItemName, getItemLink } from '../utils';
import './index.scss';

const { DEFAULT_LOCALE } = require('../../../../shared/constants');

const source = 'side-menu';

const SideMenu = ({ category }) => {

    const { locale = DEFAULT_LOCALE, isTouch } = getContext();

    return (
        <ul className={classNames('side-menu', { 'desktop': !isTouch })}>
            <li className="selected-category">{category.title}</li>
            {category.items.map((item, index) => (
                <li key={index}>
                    <a href={item && getItemLink(item.type, item.urlParams, source, locale)}>
                        {item && getItemName(item.alias, item.type, item.urlParams)}
                    </a>
                </li>))}
        </ul>
    );
};

SideMenu.propTypes = {
    category: PropTypes.object
};

export default SideMenu;
